import { removeStorageItem } from '../lib/localStorage';
import { StorageKeys } from '../enums/StorageKeys.enum';

export const logout = () => {
  removeStorageItem(StorageKeys.token);
  removeStorageItem(StorageKeys.name);
  removeStorageItem(StorageKeys.role);

  // Navigate to App
  window.location.href = '/';
};
